import {
  MetaMaskService,
} from "../../services/MetaMaskService";
import { SystemService } from "./../../services/SystemService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TDashboard = {
  balance: number | string;
  investedFunds?: number;
  earned?: number;
  annualInterest?: number;
  withrawFee? : number;
  tatalAmount? : number;
  timeDiff? : number;
};
export type TPoolboard = {
  lockTime?: number;
  apy?:number;
  withdrawFee?: number;
  stakedAmount?: number;
  compoundedAmount?: number;
}
export type TStakeStruct = {
  amount?: string | number;
  poolId?: number;
}
interface DashboardState {
  dashboard: TDashboard | null;
  isUnlocked: boolean;
  isConnectedWallet: boolean | null;
  accounts: string[];
  stakeInput?: number;
  currentAccount?: string;
  unstakedState: boolean;
  networkId?: number;
  isCurrentNetwork?: boolean;
  isMetaMaskInstalled: boolean | null;
  selectedButton: string;

  poolboard: TPoolboard[] | null;
  poolId : number | null;
}


const dashboardService: SystemService = new SystemService();
let metaMaskService: MetaMaskService;

export const login = createAsyncThunk(
  "Dashboard/login",
  async () => await dashboardService.getAccounts()
  
);

export const setDashboard = createAsyncThunk(
  "Dashboard/setDashboard",
  async (poolId : number): Promise<TDashboard> => {
    await metaMaskService.setBalance();
    const balance = metaMaskService.balance;
    const invested = await metaMaskService.getInvested(poolId);
    const earned = await metaMaskService.computeEarned(poolId);
    const apy = await metaMaskService.getPoolAPY(poolId);
    const amount = await metaMaskService.getPoolAmount(poolId);
    const fee = await metaMaskService.getWithdrawFee(poolId);
    const timeDiff  = await metaMaskService.getUnlockTime(poolId);
    return {
      balance,
      investedFunds: invested,
      earned,
      annualInterest: apy,
      withrawFee: fee,
      tatalAmount: amount,
      timeDiff : timeDiff,
    };
  }
);
export const setPoolboard = createAsyncThunk(
  "Poolboard/setPoolboard",
  async (): Promise<TPoolboard[]> => {
    let poolboards: TPoolboard[] = [];
    for (let i = 0; i < 5; i++) {
      const pool = await metaMaskService.getPoolInfo(i);
      poolboards.push(pool);
    }
    return poolboards;
  }
);


export const createStake = createAsyncThunk(
  "Dashboard/createStake",
  async (info : TStakeStruct) => {
    return await metaMaskService.Stake(info.amount!, info.poolId!);
  }
);

export const Withdraw = createAsyncThunk("Dashboard/Withdraw", async (info : TStakeStruct): Promise<boolean> => {
  return await metaMaskService.Withdraw(info.poolId!, info.amount!);
});

export const Harvest = createAsyncThunk("Dashboard/Harvest", async (pid : number): Promise<boolean> => {
  return await metaMaskService.Harvest(pid);
});

export const setNetwork = createAsyncThunk("Dashboard/setNetwork", async () => {
  return await metaMaskService.getNetworkId();
});
export const setPoolId = createAsyncThunk("Poolboard/setPoolId", async (poolId:number) => {
  return poolId;
});
export const Compound = createAsyncThunk("Dashboard/Compound", async (poolId : number): Promise<boolean> => {
  return await metaMaskService.Compound(poolId);
});
const initialState: DashboardState = {
  poolboard: null,
  dashboard: null,
  isUnlocked: false,
  isConnectedWallet: null,
  accounts: [],
  unstakedState: false,
  isMetaMaskInstalled: null,
  selectedButton: "all",
  poolId: Number(localStorage.getItem('poolId')),
};
export const DashboardSlice = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {
    connectWallet() {
      console.log("-------------------------");
      if (window["ethereum"]) {
        window["ethereum"].request({ method: "eth_requestAccounts" });
      }
    },
    exit(state) {
      console.log("-------3333------------------");
      console.log(state);
      state.dashboard = null;
      state.isConnectedWallet = false;
      state.isUnlocked = false;
      state.accounts = [];
    },
    setMetaMaskState(state, action: PayloadAction<boolean>) {
      state.isMetaMaskInstalled = action.payload;
    },
    setSelectedButton(state, action: PayloadAction<string>) {
      state.selectedButton = action.payload;
    },
  },

 extraReducers: {
    [login.fulfilled as any]: (state, { payload }) => {
      if (payload && payload.length === 0) {
        state.isConnectedWallet = false;
        return state;
      }
      state.isConnectedWallet = true;
      metaMaskService = new MetaMaskService(window["ethereum"], payload);
      state.accounts = payload;
      state.currentAccount = payload[0];
      console.log(state);
      return state;
    },
    [setDashboard.fulfilled as any]: (state, { payload }) => {
      state.dashboard = payload;
    },
   
    [createStake.fulfilled as any]: (state) => {
      return state;
    },
    [Withdraw.fulfilled as any]: (state, { payload }) => {
      state.unstakedState = payload;
    },
    [setNetwork.fulfilled as any]: (state, { payload }) => {
      state.networkId = payload;

      /**
       * Important! Checking for networkId of your MetaMask Wallet
       * If you want use Smart Chain Testnet, please add also 97 network
       */
      state.isCurrentNetwork = payload === 56 || payload === 97;
    },

    [setPoolboard.fulfilled as any]: (state, { payload }) => {
      state.poolboard = payload;
    },
    [setPoolId.fulfilled as any]: (state, { payload }) => {
      state.poolId = payload;
    },
  },

});

export default DashboardSlice.reducer;
